import React, { createContext, useReducer } from 'react'
import { randomNumber } from '../helpers'

import quizReducer from '../reducers/quizReducer'

const initialQuizValues = {
  target: randomNumber(),
  multiplier: randomNumber(),
  mode: 'true-false',
  correctAnswer: null,
  chosenAnswer: null,
  submitted: false,
  scores: [],
  starsCount: 0
}

export const QuizContext = createContext();

export const QuizProvider = (props) => {
  const [quiz, dispatch] = useReducer(quizReducer, initialQuizValues);
  return (
    <QuizContext.Provider value={ { quiz, dispatch } }>
      {props.children}
    </QuizContext.Provider>
  );
}
